<template>
  <b-modal
    ref="modal"
    id="attendees-modal"
    class="large-modal"
    title="BootstrapVue"
    size="lg"
    ok-title="Back"
    ok-only
  >
    <template #modal-header>
      <div class="upper" v-if="workshop">
        <label>{{workshop.topic}}</label>
        <div class="new-title">
          Attendees ({{workshop.attendees.length}})
        </div>
      </div>
      <button class="close" @click="hide()" >
        ×
      </button>
    </template>

    <template v-if="workshop && workshop.attendees && workshop.attendees.length">
      <table class="responsive-table">
        <thead>
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th/>
          </tr>
        </thead>
        <tbody>
          <tr v-for="attendee in workshop.attendees" :key="attendee.userId" >
            <td>
              {{ attendee.firstName }}
              <label class="d-block d-md-none">
                First Name
              </label>
            </td>
            <td>
              {{ attendee.lastName }}
              <label class="d-block d-md-none">
                Last Name
              </label>
            </td>
            <td>
              <button class="btn btn-secondary"
                @click="$emit('refund', {workshop, attendee})"
              >            
                Refund
              </button>
              <button class="btn btn-secondary"
                @click="$emit('withdraw', {workshop, attendee})" 
              >
                Withdraw
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <p v-else>There are no attendees yet.</p>
  </b-modal>
</template>

<script>
import AttendeesTable from '@/components/tables/AttendeesTable.vue';

export default {
  name: 'AttendeesModal',
  components: {
    AttendeesTable,
  },
  data() {
    return {
      workshop: null,
    };
  },
  methods: {
    show(workshop) {
      this.workshop = workshop;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
#attendees-modal {
  .upper {
    display: block;
    position: relative;
    padding-right: 30px;
  }

  label {
    @include label;

    display: block;
    margin-bottom: 10px;
  }

  .date {
    font-size: 18px;
    color: rgba(white, 0.75);
  }

  .pills {
    margin-top: 20px;
  }

  .new-title {
    display: block;
    color: white;
    font-size: 30px;
    font-weight: 700;
    font-family: "Playfair Display", serif;
    line-height: 1;
  }

  .description {
    opacity: 0.6;
  }

  h6 {
    font-weight: normal !important;
    font-size: 25px;
    margin-top: 30px;
    margin-bottom: 10px;

    span {
      font-weight: bold !important;
    }
  }

  .green {
    font-size: 13px;
    color: $green;
  }

  .avatars {
    margin-top: 20px;

    .user-avatar {
      @include background-cover;
      @include border-radius(100px);

      background-image: url('~@/assets/img/default-user.jpg');
      display: inline-block;
      height: 60px;
      width: 60px;
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }

  .text-btn {
    @include label;

    border: none;
    background: none;
    color: $green;
    padding: 0;
    outline: none;
    height: auto;
    font-weight: normal;
    margin-top: 25px;
    text-align: right;
    text-transform: none;
    opacity: 0.5;

    &:hover,
    &:focus {
      opacity: 1;
      text-decoration: underline;
    }
  }

  .responsive-table {
    @include border-radius($border-radius);

    margin-top: 30px;
    width: 100%;
    border: none;

    thead {
      background: none;
      color: white;

      th {
        position: relative;
        padding: 0.75rem;
        padding-right: $gutter;
        white-space: nowrap;
        border-bottom: 2px solid rgba(255, 255, 255, 0.25);
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;

        i,
        svg {
          position: absolute;
          top: 17px;
          right: 10px;
        }

        .fa-sort {
          z-index: 1;
          opacity: 0.2;
        }

        span {
          .fa-sort-up {
            z-index: 2;
            opacity: 0;
          }

          .fa-sort-down {
            z-index: 3;
            opacity: 0;
          }

          &.active-down {
            .fa-sort-down {
              opacity: 1;
            }
          }

          &.active-up {
            .fa-sort-up {
              opacity: 1;
            }
          }
        }

        &:hover {
          .fa-sort {
            opacity: 0.3;
          }

          span {
            .fa-sort-down {
              opacity: 1;
            }

            &.active-down {
              .fa-sort-down {
                opacity: 1;
              }

              .fa-sort-up {
                opacity: 0;
              }
            }

            &.active-up {
              .fa-sort-up {
                opacity: 1;
              }

              .fa-sort-down {
                opacity: 0;
              }
            }
          }
        }
      }
    }

    tbody {
      tr {
        td {
          padding: 0.75rem;
          color: rgba(white, 0.87);
          border-top: 1px solid rgba(255, 255, 255, 0.25);

          a {
            color: darken($highlight-color, 5%);
          }
        }
      }
    }

    .actions {
      text-align: right;
    }

    @media (max-width: $sm-max) {
      display: block;
      border: none;

      thead,
      tbody,
      th,
      td,
      tr {
        display: block;
      }

      tbody {
        tr {
          background: $dark-blue;
          border: solid 1px $border-color;

          td {
            padding: 0.75rem;
            text-align: right;
            border-bottom: none;
            border-top: 1px solid rgba(255, 255, 255, 0.25);

            &:first-of-type {
              border-top: none;
            }

            &:last-of-type {
              border-bottom: none;
            }
          }
        }
      }

      thead tr {
        position: absolute;
        top: -9999px;
        left: -9999px;
      }

      tr {
        @include border-radius($border-radius);

        margin: 0 0 1rem 0;
        background: white;
      }

      td {
        position: relative;
        padding-left: 50%;
        border: none;
        border-bottom: $secondary-border;

        label {
          position: absolute;
          top: 12.5px;
          left: 15px;
          width: 45%;
          padding-right: 10px;
          font-weight: bold;
          white-space: nowrap;
          text-align: left;
        }
      }

      .btn-ghost {
        border-color: $primary-color;
        background: $primary-color;
        color: $btn-color;
        height: 45px;

        &:hover,
        &:focus {
          border-color: darken($primary-color, 5%);
          background-color: darken($primary-color, 5%);
          color: $btn-color;
        }
      }
    }

    .icons {
      color: $green;
      text-align: right;
    }
  }
}
</style>
